import { useEffect, useRef } from 'react';

interface TableConfig {
  visibleColumns: string[];
  columnOrder: string[];
}

const arraysEqual = (a: string[], b: string[]): boolean =>
  a.length === b.length && a.every((v, i) => v === b[i]);

const configsEqual = (a: TableConfig, b: TableConfig): boolean =>
  arraysEqual(a.visibleColumns, b.visibleColumns) && arraysEqual(a.columnOrder, b.columnOrder);

export interface UseNotifyTableConfigChangeParams {
  config: TableConfig;
  enabled: boolean;
  onChange?: (config: TableConfig) => void;
}

const useNotifyTableConfigChange = ({
  config,
  enabled,
  onChange,
}: UseNotifyTableConfigChangeParams): void => {
  const previousRef = useRef<TableConfig | null>(null);

  useEffect(() => {
    if (!enabled || !onChange) return;

    const previous = previousRef.current;
    if (previous && configsEqual(previous, config)) return;

    previousRef.current = config;
    onChange(config);
  }, [config, enabled, onChange]);
};

export default useNotifyTableConfigChange;
